module.exports = __webpack_public_path__ + "img/cons_1.a759bad2.jpg";